import { fork, call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import history from "../../../../history/history";
import {
  getPrimaryAccount,
  getAccountData
} from "../../../../utils/sessionUtil";
import { makeAContributionAPI, ViewContributionAPI } from "../../../../services/drupalServices";
import * as actionTypes from "./actionTypes";
import { handlerServerSideErrorsGlobal } from "../../../../sagas/globalSaga";
export function* getAPIDataWorker(fetchPayload){

  try {
    const pageInfo = yield call(
      makeAContributionAPI.step1Content
    );
    const step1Notice = yield call(
      makeAContributionAPI.step1Notice
    );
    const step1Alert = yield call(
      makeAContributionAPI.alertBox
    );
    const page1Info = {pageInfo: pageInfo.data[0], step1Notice: step1Notice.data[0], step1Alert: step1Alert.data};  
       yield put({
      type: actionTypes.makeAContributionDrupalDataType,
      payload: {response : page1Info}
    });
    const fetchObj = fetchPayload.payload.metaData;
    const fetchUrls = fetchPayload.payload.metaData.url;
    const firstApiCall = {
      'additionalDetails': fetchUrls['additionalDetails'],
      'dropDownValues': fetchUrls['dropDownValues'],
      'loggedInAddress': fetchUrls['loggedInAddress'],
      'investmentAllocation' : fetchUrls['investmentAllocation']
    };

    const relationShipValues  ={...fetchUrls['relationShipValues'],method:fetchObj.method};

    delete fetchUrls['investmentAllocation'];
    delete fetchUrls['additionalDetails'];
    delete fetchUrls['dropDownValues'];
    delete fetchUrls['loggedInAddress'];
    delete fetchUrls['relationShipValues'];

    const fetchArr = [];
    const firstApiCallKeys = Object.keys(firstApiCall);
    for (const key of firstApiCallKeys) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: firstApiCall[key]
        });
        fetchArr.push(keyObj);
    }

    fetchArr.push(relationShipValues);
    const fetchedData = yield all(
      fetchArr.map(each => call(fetchAccountData, each))
    );
  
    yield put({
      type: actionTypes.updateAdditionalDataType,
      payload: fetchedData[0].data
    })
    if(fetchedData[0].data.accessKeyGeneratedAndActive){
      const accessKeyPayload = {
        metaData: {
          method: "GET",        
        url: `/donor-portal/api/profile/${getPrimaryAccount().userId}/generateAccessKeyWithAccountIdAndPartyId?partyId=${getAccountData().partyId}`,
        },
        isKeyGenerated: true
      }
      yield put({
        type: actionTypes.contributionAccessKeyApiCalledType,
        payload: false
      })
      yield call(fetchAccesskeyWorker, {payload : accessKeyPayload});
    } else {
      yield put({
        type: actionTypes.contributionAccessKeyApiCalledType,
        payload: true
      })
    }
    yield put({
      type: actionTypes.contributionDropdownDataSuccessType,
      payload: { response: fetchedData[1].data, fetchPayload: fetchPayload.payload }
    });
    yield put({
      type: actionTypes.contributionLoggedInAddressType,
      payload: {response : fetchedData[2].data }
    });
    yield put({
      type: actionTypes.contributionInvestmentDataSuccessType,
      payload: { response: fetchedData[3].data, fetchPayload: fetchPayload.payload }
    });

    yield put({
      type: actionTypes.relationShipDataSuccessType,
      payload: { response: fetchedData[4].data}
    });


    const fetchRemaining = [];
    const fetchUrlsKeys = Object.keys(fetchUrls);
    for (const key of fetchUrlsKeys) {
        const keyObj = Object.assign({
          method: fetchObj.method,
          url: fetchUrls[key]
        });
        fetchRemaining.push(keyObj);
    }
    const fetchedArr = yield all(
      fetchRemaining.map(each => call(fetchAccountData, each))
    );
   
    yield put({
      type: actionTypes.contributionFundDetailsDataSuccessType,
      payload: { response: fetchedArr[0].data, fetchPayload: fetchPayload.payload }
    });
    yield put({
      type: actionTypes.contributionYearWiseBalanceDetailsType,
      payload: {response : fetchedArr[1].data }
    });
    const step2Notice = yield call(
      makeAContributionAPI.step2Notice
    );
    const step3Disclaimer = yield call(
      makeAContributionAPI.step3Disclaimer
    );
    const wiringInstructions = yield call(
      makeAContributionAPI.wiringInstructions
    );
    const confirmationNotice = yield call(
      ViewContributionAPI.getNotice
    );
    const confirmationSuccessMessage = yield call(
      makeAContributionAPI.successMessage
    )
    let drupalData = {step2Notice: step2Notice.data[0], step3Disclaimer: step3Disclaimer.data[0], wiringInstructions: wiringInstructions.data[0], confirmationNotice: confirmationNotice.data[0], confirmationSuccessMessage: confirmationSuccessMessage.data[0] };  
    yield put({
      type: actionTypes.makeAContributionDrupalData2Type,
      payload: {response : drupalData}
    });
     
  } catch (error) {
    yield put({
      type: actionTypes.contributionDataFailureType,
      payload: error
    });
  }
}

export function submitPostData(payload) {
  const submitInterface = asyncInterface.init();
  let data = submitInterface.makeAContribution.submitData(payload)
  return data;
}

export function* submitContributionWorker(submitPayload){
  try {
    const response = yield call(submitPostData, submitPayload.payload);
    submitPayload.payload.submitDone();
    yield put({type: actionTypes.postCreateContributionSuccessType ,payload: response.data});
    yield call(history.push, "/contributions/make-a-contribution/funding-instructions");    
  } catch (error) {
    submitPayload.payload.submitDone(error);
    yield handlerServerSideErrorsGlobal({error,type:'default',errorCodes:[504,500,503]});
    yield put({
      type: actionTypes.postCreateContributionErrorType,
      error
    });
  }
}

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  const data = fetchData.makeAContribution.fetchAccountData(fetchPayload);
  return data;
}

export function* fetchAccesskeyWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload.metaData);
    yield put({
      type: actionTypes.contributionAccessKeySuccessType,
      payload: {response: response.data}
    });
    if(!fetchPayload.payload.isKeyGenerated){
        const additionalDetails = {metaData: {
          method: "GET",        
        url: `/donor-portal/api/account/${getPrimaryAccount().userId}/findBalancesAndVGAccessKey`,
        }}
        const updatedDetails = yield call(fetchAccountData, additionalDetails.metaData)
        yield put({
          type: actionTypes.updateAdditionalDataType,
          payload: updatedDetails.data
        })
    }

  } catch (error) {
    yield put({
      type: actionTypes.contributionAccessKeyFailedType,
      error
    });
  }
}
export function* fetchTickerList(fetchPayload) {
  try {
      const response = yield call(
              fetchAccountData,
              fetchPayload.payload.metaData
          );
    yield put({
      type: actionTypes.fetchTickerSuccessType,
      payload: {response: response ? response.data:[]}
    });
  }
   catch (error) {
    yield put({
      type: actionTypes.fetchTickerFailureType,
      payload: {response:[]}
    });
  }
}
export function* fetchPriceValue(fetchPayload) {
    try {
        const response = yield call(
          fetchAccountData,
          fetchPayload.payload.value.metaData
        );
        if(response && response.data && !response.data.errorMessage) {
          yield put({
            type: actionTypes.fetchPriceSuccessType,
            payload: {
              value: response.data.price,
              date: response.data.priceDate,
              assetHeld:fetchPayload.payload.assetHeld,
              contributionType:fetchPayload.payload.contributionType,
              accountId:fetchPayload.payload.accountId,
              fundType:fetchPayload.payload.fundType,
              donorId:fetchPayload.payload.donorId,
            }
          });
        }
    }
    catch (error) {
      yield put({
        type: actionTypes.fetchPriceFailureType,
         payload: {
          value: 0,
          date: "",
          assetHeld:fetchPayload.payload.assetHeld,
          contributionType:fetchPayload.payload.contributionType,
          accountId:fetchPayload.payload.accountId,
          fundType:fetchPayload.payload.fundType,
          donorId:fetchPayload.payload.donorId,
        }
       });
     }
   }

export function* investmentAndFundDetailsWatcher(){
  yield takeEvery( actionTypes.getAPIDataType ,getAPIDataWorker);
}

export function* createContributionWatcher(){
  yield takeLatest( actionTypes.createContributionType , submitContributionWorker);
}

export function* fetchAccessKeyWatcher() {
  yield takeLatest( actionTypes.generateAccesKeyType , fetchAccesskeyWorker);
}
export function* fetchTickerFromMngStar() {
  yield takeLatest( actionTypes.fetchTickerType , fetchTickerList);
}
export function* fetchPriceMngStar() {
   yield takeLatest( actionTypes.fetchPriceType , fetchPriceValue);
}

export default function* makeAContributionWatcher() {
    yield all([
      fork(investmentAndFundDetailsWatcher),
      fork(createContributionWatcher),
      fork(fetchAccessKeyWatcher),
      fork(fetchTickerFromMngStar),
      fork(fetchPriceMngStar)
    ]);
  }
  